import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper/bundle';

export default class extends Controller {
  static targets = ["container", "pagination", "next", "prev", "heroCard", "heroContent"]

  connect() {
    this.swiper = new Swiper(this.containerTarget, {
      loop: false, // Set false agar logic index 0 Hero Feature akurat
      speed: 1000, // Kecepatan transisi slide
      effect: 'fade', // Effect fade untuk background
      mousewheel: true,
      fadeEffect: { crossFade: true },
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      
      navigation: {
        nextEl: this.nextTarget,
        prevEl: this.prevTarget,
      },
      
      pagination: {
        el: this.paginationTarget,
        clickable: true,
        // MAGIC DISINI: Kita render bullet pakai class Tailwind!
        renderBullet: function (index, className) {
          return `<span class="${className} block w-2 h-2 rounded-full opacity-100! bg-white! [&.swiper-pagination-bullet-active]:bg-green-600! cursor-pointer transition-all duration-300 mx-1"></span>`;
        },
      },
      
      on: {
        init: (swiper) => {
          this.animateElements(swiper);
          this.animateHero(swiper);
        },
        slideChange: (swiper) => {
          this.animateElements(swiper);
          this.animateHero(swiper);
        }
      }
    });

    // Handle Click Slide untuk Navigasi (Turbo)
    this.swiper.on('click', (swiper) => {
      const activeSlide = swiper.slides[swiper.activeIndex];
      const url = activeSlide.dataset.url;
      if (url) {
        // window.location.href = url; // Atau gunakan Turbo.visit(url)
        Turbo.visit(url); 
      }
    });
  }

  // Animasi Teks Kategori (Kanan Bawah)
  animateElements(swiper) {
    // 1. Reset semua animasi di semua slide
    swiper.slides.forEach((slide) => {
      const title = slide.querySelector('[data-home-animate="title"]');
      if (title) {
        title.classList.remove('opacity-100', 'translate-x-0');
        title.classList.add('opacity-0', 'translate-x-10');
      }
    });

    // 2. Jalankan animasi di slide aktif
    const activeSlide = swiper.slides[swiper.activeIndex];
    const activeTitle = activeSlide.querySelector('[data-home-animate="title"]');
    
    if (activeTitle) {
      // Sedikit delay agar background muncul dulu
      setTimeout(() => {
        activeTitle.classList.remove('opacity-0', 'translate-x-10');
        activeTitle.classList.add('opacity-100', 'translate-x-0');
      }, 100);
    }
  }

  // Animasi Hero Feature (Putih Kiri Atas) - Slide 0 Saja
  animateHero(swiper) {
    // Cek apakah ada target Hero di DOM
    if (!this.hasHeroCardTarget) return;

    if (swiper.activeIndex === 0) {
      // Jika Slide 0: Turunkan Card (Slide Down)
      this.heroCardTarget.classList.remove('-translate-y-full');
      this.heroCardTarget.classList.add('translate-y-0');
      
      // Fade In Content di dalam Card
      if(this.hasHeroContentTarget) {
        this.heroContentTarget.classList.remove('opacity-0');
        this.heroContentTarget.classList.add('opacity-100');
      }
    } else {
      // Jika Slide Lain: Naikkan Card (Hide)
      this.heroCardTarget.classList.remove('translate-y-0');
      this.heroCardTarget.classList.add('-translate-y-full');
      
      if(this.hasHeroContentTarget) {
        this.heroContentTarget.classList.remove('opacity-100');
        this.heroContentTarget.classList.add('opacity-0');
      }
    }
  }

  disconnect() {
    if (this.swiper) this.swiper.destroy();
  }
}